import { render } from "./NavigationStats.vue?vue&type=template&id=f3e5e50e&scoped=true&ts=true"
import script from "./NavigationStats.vue?vue&type=script&lang=ts"
export * from "./NavigationStats.vue?vue&type=script&lang=ts"

import "./NavigationStats.vue?vue&type=style&index=0&id=f3e5e50e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e5e50e"]])

export default __exports__